module.exports = __webpack_public_path__ + "img/furniture-de.0437583b.svg";